import {AsyncState, GetUsersProfilesResult, useAuthContainer, useCallable} from '@ozark/common';
import {isEqual} from 'lodash';
import {useCallback, useEffect, useState} from 'react';
import {createContainer} from 'unstated-next';

function useUserProfiles() {
  const [userProfiles, setUserProfiles] = useState<AsyncState<GetUsersProfilesResult>>({
    promised: true,
  });
  const {getUsersProfiles} = useCallable();
  const {authUser} = useAuthContainer();
  const loadUserProfiles = useCallback(
    async (existingUserProfiles: GetUsersProfilesResult | undefined) => {
      if (!authUser.data?.uid) {
        return;
      }
      const profiles = await getUsersProfiles();
      if (profiles.status === 'error') {
        return;
      }
      if (!existingUserProfiles || existingUserProfiles.status === 'error') {
        setUserProfiles({promised: false, data: profiles});
        return;
      }
      let changesExist = false;
      for (const profileId of Object.keys(profiles.profilesDictionary)) {
        const profile = profiles.profilesDictionary[profileId];
        const existingUserProfile = existingUserProfiles.profilesDictionary[profileId];
        if (!existingUserProfile || !isEqual(existingUserProfile, profile)) {
          changesExist = true;
          break;
        }
      }
      if (changesExist) {
        //avoid updating user profiles if there are no changes, because otherwise we might get an infinite loop
        setUserProfiles({promised: false, data: profiles});
      }
    },
    [authUser.data?.uid]
  );

  useEffect(() => {
    loadUserProfiles(undefined);
  }, [loadUserProfiles]);

  return {
    userProfiles,
    loadUserProfiles,
  };
}

export const UserProfilesContainer = createContainer(useUserProfiles);
export const useUserProfilesContainer = UserProfilesContainer.useContainer;
